import { css, SerializedStyles } from '@emotion/core';

const wrapper: SerializedStyles = css`
  align-items: center;
`;

const input: SerializedStyles = css`
  width: 100%;
  border: none;
  outline: none;
  font-style: italic;
`;

export default {
  wrapper,
  input,
};
